const PasswordValidator = require('password-validator');
const passwordValidator = new PasswordValidator();

// Add properties to it
passwordValidator
    .is().min(8) // Minimum length 8
    .is().max(100) // Maximum length 100
    .has().uppercase() // Must have uppercase letters
    .has().lowercase() // Must have lowercase letters
    .has().digits(1) // Must have at least 1 digits
    .has().not().spaces() // Should not have spaces
    .is().not().oneOf([
      'Passw0rd',
      'Password123',
    ]); // Blacklist these values

function validatePassword(v) {
  return /^[A-Za-z0-9_\-!&`2#$%@^*}{\[\]()=+?/\\'"<>.,|:;~]+$/.test(v);
}

validatePassword.week = (v) => passwordValidator.validate(v);

module.exports = validatePassword;
